import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';



/**
 * 同步到公众号
 * 页面：公众号群发页
 * 前端：洪芳
 * 后端： 陈陈
 * @params {Object} params: demo传参对象
 */
export async function uploadNews(params) {
  return request(`${url.url}/subscription/uploadNews?${stringify(params)}`);
}



